var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.document)?_c('simple-text',{attrs:{"content":_vm.document.clientOriginalFileName,"title":_vm.document.clientOriginalFileName}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }